import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { MatDialog } from '@angular/material/dialog';
import { EditClientComponent } from '../edit-client/edit-client.component';
import { CertificationClientComponent } from './list-customers.component';

@Component({
    selector: 'app-buttoncustomer-renderer',
    template: `
        <div *ngIf="params.autorisation === null" class="text-center">
            <button style="border: none; margin-right: 3px;border-radius:50%" type="button" class="btn-success"
                    (click)="editCustomer(params)" title="Modifier">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
            </button>
        </div>

        <div *ngIf="params.autorisation !== null" class="text-center">
            <button style="border: none; margin-right: 3px;border-radius:50%" type="button" (click)="certified(params)"
                    title="Certifier">
                <i class="fa fa-certificate fa-pulse fa-spin fa-1x text-green" aria-hidden="true"></i>
            </button>
        </div>
    `

})

export class ButtonCustomerRendererComponent implements ICellRendererAngularComp {

    params: any;


    constructor(
        public dialog: MatDialog,
    ) {
    }

    agInit(params): void {
        this.params = params;
    }

    refresh(params?: any): boolean {
        return true;
    }

    editCustomer(params) {
        const dialogue = this.dialog.open(EditClientComponent, {
            width: '50%',
            height: '60%',
            data: { client: params.data },
        });
        dialogue.afterClosed().subscribe(
            () => {
                this.params.api.refreshInfiniteCache();
            }
        );
    }

    certified(params) {
        const dialogue = this.dialog.open(CertificationClientComponent, {
            width: '30%',
            height: '15%',
            data: { client: params.data },
        });/*
    let clientSearch: ClientSearch = new ClientSearch();
    clientSearch.siren = params.data.siren;
    clientSearch.siret = params.data.siret;
    clientSearch.crmId = params.data.crmId;
    this.clientService.certified(clientSearch).subscribe(
      () => {
        this.toastr.success('Le client a bien été certifié.', '', {timeOut: 7000});
        location.reload();
      },
      () => {
        this.toastr.error('Problème lors de la certification du client.', '', {timeOut: 7000});
      }
    );*/
    }
}
